import { Box, Button, ButtonGroup, Stack, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { AccordionGlobalDocumentTable } from './AccordionGlobalDocumentTable'
import { useState } from 'react'
import { DocumentViewMode } from '../../../enums'
import { MdCategory, MdList } from 'react-icons/md'
import { GlobalDocumentsTable } from './GlobalDocumentTable'
import { getThemeColor } from 'src/utils'
import { MUIThemeColors } from 'src/mui-theme'

export const GlobalDocumentForApprovalContainer = () => {
  const { t } = useTranslation(['global-documents', 'common'])
  const { id: customerId } = useParams()
  const theme = useTheme()
  const [viewMode, setViewMode] = useState<DocumentViewMode>(DocumentViewMode.Category)

  return (
    <Box
      padding={'8px'}
      bgcolor={getThemeColor(theme, MUIThemeColors.white)}
      borderRadius={'4px'}
      minHeight={window.innerHeight - 280}
    >
      <Stack direction="column" justifyContent="center" spacing={2} marginBottom={1}>
        <ButtonGroup variant="outlined">
          <Button
            onClick={() => setViewMode(DocumentViewMode.Category)}
            variant={viewMode === DocumentViewMode.Category ? 'contained' : 'outlined'}
            startIcon={<MdCategory />}
          >
            {t('category', { ns: 'common' })}
          </Button>
          <Button
            onClick={() => setViewMode(DocumentViewMode.List)}
            variant={viewMode === DocumentViewMode.List ? 'contained' : 'outlined'}
            startIcon={<MdList />}
          >
            {t('list', { ns: 'common' })}
          </Button>
        </ButtonGroup>
      </Stack>
      <>
        {viewMode === DocumentViewMode.Category ? (
          <>
            <AccordionGlobalDocumentTable customerId={customerId!} IsApprovedDocs={false} />
          </>
        ) : (
          <GlobalDocumentsTable
            customerId={customerId as EntityId}
            IsApprovedDocs={false}
            height={'62vh'}
            rowHeight={40}
          />
        )}
      </>
    </Box>
  )
}
